import React, { PureComponent } from 'react';

import DataLayerFactory from '../DataLayer/Utils/Factory';

import TimeNavigation from './TimeNavigation';
import * as TimingActions from './TimingState';
import debounce from 'lodash/debounce';

import './timinghandler.scss';

class TimingHandler extends PureComponent {

  static childContextTypes = {
    layerContainer: React.PropTypes.shape({
      addLayer: React.PropTypes.func.isRequired,
      removeLayer: React.PropTypes.func.isRequired,
    })
  }

  constructor(props) {
    super(props);
    const { dispatch } = props;
    this.debounceTime = 50;

    this.setTimeStepDebounced = debounce((ts) => {
      dispatch(TimingActions.setTimeStep(ts));
      dispatch(TimingActions.resumeAnimation());
    }, this.debounceTime, { trailing: true, leading: false });

    this.sliderChangeHandler = ts => {
      dispatch(TimingActions.setIdleMode(false));
      dispatch(TimingActions.setVisibleTimeStamp(ts));
      dispatch(TimingActions.clearAnimation());

      this.setTimeStepDebounced(ts);
    };
    this.setTimeNavigation = payload => dispatch(TimingActions.setTimeNavigation(payload));
    this.togglePlaying = () => {
      dispatch(TimingActions.setIdleMode(false));
      dispatch(TimingActions.togglePlaying());
    };

    this.dataLayerCache = {};
    this.getCachedDataLayer = this.getCachedDataLayer.bind(this);
  }

  componentWillUnmount() {
    this.dataLayerCache = {};
  }

  getChildContext() {
    return {
      layerContainer: this.props.layerContainer,
    };
  }

  getCachedDataLayer(dl, i) {
    // check if overlay is already mounted
    const dlId = `${dl.type}_${dl.url}_${i}`;
    const { props } = this;
    const { currentTimestamp, isBuffering, tilesLoaded, store, layerContainer, overlaySettingsHandler } = props;
    let result = null;
    let { toggleLoadingApp } = props;

    if (typeof toggleLoadingApp === 'undefined') {
      toggleLoadingApp = () => {};
    }

    if (this.dataLayerCache[dlId]) {
      // extend existing layers with current timeNavigation data
      result = React.cloneElement(this.dataLayerCache[dlId], { currentTimestamp, isBuffering, tilesLoaded });
    } else {
      result = DataLayerFactory.getLayerByType(dl.type, {
        ...dl,
        currentTimestamp,
        tilesLoaded,
        leafletMap: layerContainer,
        store,
        layerContainer,
        overlaySettingsHandler,
        toggleLoadingApp
      });

      this.dataLayerCache[dlId] = result;
    }

    return result;
  }

  render() {
    const showTimeNavigation = this.props.timeNavigation;
    const dataLayerTimeConnected = this.props.dataLayer.filter(dl => dl && dl.timeConnected ? !!dl.timeConnected : false);
    const dataLayer = dataLayerTimeConnected.map(this.getCachedDataLayer);

    return dataLayer.length ?
      (<div>
        {dataLayer}
        {showTimeNavigation ?
          <TimeNavigation
            id={this.props.id}
            handler={this.sliderChangeHandler}
            playHandler={this.togglePlaying}
            isPlaying={this.props.isPlaying}
            tilesLoaded={this.props.tilesLoaded}
            currentTimestamp={this.props.currentTimestamp}
            visibleTimestamp={this.props.visibleTimestamp}
            timeNavigation={this.props.timeNavigation}
            show_date={this.props.show_date}
            show_time={this.props.show_time}
          >
            {this.props.children}
          </TimeNavigation> : null
        }
      </div>) : null;
  }

}

TimingHandler.propTypes = {
  dataLayer: React.PropTypes.array
};

TimingHandler.defaultProps = {
  dataLayer: []
};

export default TimingHandler;



/** WEBPACK FOOTER **
 ** ./core_components/TimingHandler/TimingHandler.js
 **/